import { API, axiosInstance } from "lib";

export const planImport = (data = {}) => {
  return axiosInstance
    .post(API.PLAN + "import_plan", data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const addressImport = (data = {}) => {
  return axiosInstance
    .post(API.ACCOUNT + "import_addressbook", data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const fuelCardImport = (data = {}) => {
  return axiosInstance
    .post(API.FUEL_CARD + "import_fuelcard", data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const fastagImport = (data = {}) => {
  return axiosInstance
    .post(API.FASTAG + "import_fastag", data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const contractRateImport = (data = {}) => {
  return axiosInstance
    .post(API.ACCOUNT + "import_zone", data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const lrRateImport = (data = {}) => {
  return axiosInstance
    .post(API.LR_IMPORT , data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};


export const jklrRateImport = (data = {}) => {
  return axiosInstance
    .post(API.JK_LR_IMPORT , data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const adaniLrRateImport = (data = {}) => {
  return axiosInstance
    .post(API.ADANI_LR_IMPORT , data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};
// export const planImport = (data = {}) => {
//   return axiosInstance
//     .post(API.PLAN + "import_plan", data, {
//       headers: { "Content-Type": "multipart/form-data" },
//     })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((err) => {
//       if (err) {
//         console.log(err);
//       }
// //      throw err;
//     });
// };

export const genPanelityImport = (data = {}) => {
  return axiosInstance
    .post(API.GAIN_PENALTY_IMPORT , data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const ioclFuelImport = (data = {}) => {
  return axiosInstance
    .post(API.IOCL_FUEL_UPLOAD , data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};
